const SPANISH ={
    "page_exit":"Salió de la pagina",
    "path":"Ruta",
    "page_view":"Entró a la pagina",
    "video_start":"Inició un video",
    "video_pause": "Pausó un video",
    "video_name": "Nombre del video",
    "download": "Descargó un material",
    "time_on_page": "Tiempo en la pagina",
    "file_name": "Nombre del archivo",
    "file_type": "Tipo de archivo",
    "title": "Titulo",
    "percentage_played": "Porcentaje del video reproducido"
}

export default SPANISH;